module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Light-Hestia.41f3801.eot";